import React from "react";
import { useTranslation } from "react-i18next";

import { Grid } from "@material-ui/core";
import styled from "styled-components";
import { buttonGradient } from "../../common/materials/LinearGradient";

import Dialog from "@material-ui/core/Dialog";

const StyledParticipateWrapper = styled(Grid)`
  text-align: center;
  padding: 1em 2em;
`;

const StyledHeadingTextWrapper = styled.div`
  font-size: 1.5em;
  padding-bottom: 1.5em;
  font-family: Calibre-Regular;
  color: #5298e3;
  font-weight: bold;
`;

const StyledTextWrapper = styled.div`
  font-size: 1.5em;
  font-family: Calibre-Regular;
  color: ${(props) => props.theme.colors.base.grey};
`;

const StyledButton = styled.button`
  color: ${(props) => props.theme.colors.base.white};
  font-size: 1.2em;
  padding: 0.5em 0.5em;
  padding-top: 15px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 20px;
  text-align: center;
  width: 80px;
  border-radius: 10px;
  font-family: Calibre-SemiBold;
  background: ${(props) => props.theme.colors.base.buttonGradientFirstColor};
  background: ${buttonGradient};
  border: 1px solid ${(props) => props.theme.colors.base.white};
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }
`;
interface IProps {
  onCloseHandler: () => void;
}

const UserDeactivate = (props: IProps) => {
  const { t } = useTranslation();
  const { onCloseHandler } = props;

  return (
    <div>
      <Dialog aria-labelledby="simple-dialog-title" open={true}>
        <StyledParticipateWrapper item md={12} xs={12} lg={12}>
          <StyledHeadingTextWrapper>
            {t("trans:error")}{" "}
          </StyledHeadingTextWrapper>
          <StyledTextWrapper>
            {t("common:blockUserPopup:firstLine")}
          </StyledTextWrapper>
          <StyledTextWrapper>
            {t("common:blockUserPopup:secondLine")}
          </StyledTextWrapper>
          <StyledButton onClick={onCloseHandler}>
            {t("common:button:ok")}
          </StyledButton>
        </StyledParticipateWrapper>
      </Dialog>
    </div>
  );
};

export default UserDeactivate;
